import React, { useState, useEffect } from 'react';

import { Modal, Checkbox, Space, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { ORDER_ITEM_SECONDARY_COLUMNS } from '@utils/orders/orderItemSecondaryColumns';

/**
 * Modal for configuring OrderItem secondary columns
 */
const OrderItemColumnsSettingModal = ({
  visible,
  onOk,
  onCancel,
  availableColumns = [],
  initialEnabledColumns = [],
  loading = false
}) => {
  const { t } = useTranslation();
  const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    if (visible) {
      // Filter out columns no longer in availableColumns (e.g. removed custom_attributes)
      setSelectedColumns(initialEnabledColumns.filter(col => availableColumns.includes(col)));
    }
  }, [visible, initialEnabledColumns, availableColumns]);

  const handleOk = () => {
    console.log('[OrderItemColumnsSettingModal] handleOk clicked, selectedColumns:', selectedColumns);
    if (onOk) {
      onOk(selectedColumns);
    } else {
      console.error('[OrderItemColumnsSettingModal] onOk prop is missing');
    }
  };

  const handleCancel = () => {
    // 重置為初始狀態
    setSelectedColumns(initialEnabledColumns);
    onCancel();
  };

  const handleCheckboxChange = (column, checked) => {
    if (checked) {
      setSelectedColumns(prev => [...prev, column]);
    } else {
      setSelectedColumns(prev => prev.filter(col => col !== column));
    }
  };

  const handleSelectAll = () => {
    setSelectedColumns(availableColumns);
  };

  const handleClearAll = () => {
    setSelectedColumns([]);
  };

  // Labels are derived from ORDER_ITEM_SECONDARY_COLUMNS so that adding a new
  // column on the backend (and to the shared const) needs no edit here.
  const columnLabels = Object.fromEntries(
    ORDER_ITEM_SECONDARY_COLUMNS.map((col) => [col, t(`models.order_item.${col}`)]),
  );

  return (
    <Modal
      title={t('admin.orders.form.configure_secondary_columns')}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText={t('common.button.save')}
      cancelText={t('common.button.cancel')}
      width={500}
    >
      <div style={{ marginBottom: 16 }}>
        <Space>
          <a onClick={handleSelectAll}>{t('common.button.select_all')}</a>
          <Divider type="vertical" />
          <a onClick={handleClearAll}>{t('common.button.clear_all')}</a>
        </Space>
      </div>

      <Space direction="vertical" style={{ width: '100%' }}>
        {availableColumns.map(column => (
          <Checkbox
            key={column}
            checked={selectedColumns.includes(column)}
            onChange={(e) => handleCheckboxChange(column, e.target.checked)}
          >
            {columnLabels[column] || column}
          </Checkbox>
        ))}
      </Space>

      <Divider />

      <div style={{ color: '#666', fontSize: '12px' }}>
        {t('admin.orders.form.secondary_columns_help')}
      </div>
    </Modal>
  );
};

export default OrderItemColumnsSettingModal;
